// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Nav$Web from "./Nav.res.js";
import * as Common$LumiI18n from "lumi-i18n/lib/es6/src/Common.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Translation$LumiI18n from "lumi-i18n/lib/es6/src/Translation.res.js";

function translate(locale, entry) {
  switch (locale) {
    case "DAN" :
      switch (entry) {
        case "Dark" :
          return "Mørk";
        case "Light" :
          return "Lys";
        case "System" :
          return "System";
      }
    case "DEU" :
      switch (entry) {
        case "Dark" :
          return "Dunkel";
        case "Light" :
          return "Hell";
        case "System" :
          return "System";
      }
    case "ENG" :
      switch (entry) {
        case "Dark" :
          return "Dark";
        case "Light" :
          return "Light";
        case "System" :
          return "System";
      }
    case "FRA" :
      switch (entry) {
        case "Dark" :
          return "Sombre";
        case "Light" :
          return "Clair";
        case "System" :
          return "Système";
      }
    case "ITA" :
      switch (entry) {
        case "Dark" :
          return "Scuro";
        case "Light" :
          return "Chiaro";
        case "System" :
          return "Sistema";
      }
    case "NLD" :
      switch (entry) {
        case "Dark" :
          return "Donker";
        case "Light" :
          return "Licht";
        case "System" :
          return "Systeem";
      }
    case "SLK" :
      switch (entry) {
        case "Dark" :
          return "Tmavý";
        case "Light" :
          return "Svetlý";
        case "System" :
          return "Systém";
      }
    case "SPA" :
      switch (entry) {
        case "Dark" :
          return "Oscuro";
        case "Light" :
          return "Claro";
        case "System" :
          return "Sistema";
      }
    case "SWE" :
      switch (entry) {
        case "Dark" :
          return "Mörk";
        case "Light" :
          return "Ljus";
        case "System" :
          return "System";
      }
  }
}

let T = Translation$LumiI18n.MakeProvider({
  defaultLocale: "ENG",
  translate: translate
});

function setThemeAndElt(setTheme) {
  return t => {
    let attr = "data-theme";
    let element = document.documentElement;
    switch (t) {
      case "Dark" :
        element.setAttribute(attr, "dark");
        break;
      case "Light" :
        element.setAttribute(attr, "light");
        break;
      case "System" :
        element.removeAttribute(attr);
        break;
    }
    setTheme(param => t);
  };
}

function use() {
  let match = React.useState(() => "System");
  return [
    match[0],
    setThemeAndElt(match[1])
  ];
}

let CNav = Nav$Web.Make({
  translate: Common$LumiI18n.Provider.translate
});

let Nav = Nav$Web.Make({
  translate: T.translate
});

function Theme(props) {
  let match = use();
  let setTheme = match[1];
  let theme = match[0];
  let isActive = title => title === theme;
  let tmp;
  switch (theme) {
    case "Dark" :
      tmp = "moon";
      break;
    case "Light" :
      tmp = "sun";
      break;
    case "System" :
      tmp = "circle-half-stroke";
      break;
  }
  return JsxRuntime.jsxs(CNav.DropDown.make, {
    title: "Theme",
    icon: tmp,
    isRight: true,
    children: [
      JsxRuntime.jsx(Nav.Button.make, {
        title: "Light",
        icon: "sun",
        isActive: isActive,
        onClick: param => setTheme("Light")
      }),
      JsxRuntime.jsx(Nav.Button.make, {
        title: "Dark",
        icon: "moon",
        isActive: isActive,
        onClick: param => setTheme("Dark")
      }),
      JsxRuntime.jsx(Nav.Button.make, {
        title: "System",
        icon: "circle-half-stroke",
        isActive: isActive,
        onClick: param => setTheme("System")
      })
    ]
  });
}

let make = Theme;

export {
  T,
  setThemeAndElt,
  use,
  CNav,
  Nav,
  make,
}
/* T Not a pure module */
